import HttpRequest from './HttpRequest';

// Root API class. Domain APIs (AuthAPI, AppointmentsAPI) extend this so they
// share the same HttpRequest plumbing — same pattern as stratum-analytical.
class BaseAPI extends HttpRequest {
  constructor(uri) {
    super(uri, { contentType: 'application/json' });
  }
}

// A key for one attempt at a write, so a request the browser retries by itself
// is not applied twice.
//
// It has to be unique per *click*, not per person-per-minute: a key built from
// the clock makes a second genuine attempt inside the same minute look like a
// retry of the first, and the server replays the earlier row instead of doing
// the new thing. Clocking in, out, and in again within one minute did exactly
// that — the third press silently returned the shift that had just been closed.
export function newIdempotencyKey(prefix) {
  const id = globalThis.crypto?.randomUUID
    ? globalThis.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  return `${prefix}:${id}`.slice(0, 64);
}

export const BaseService = new BaseAPI('');
export default BaseAPI;
